import { ThemeOptions } from '@mui/material/styles';

export const themeOptions = {} as ThemeOptions;
